<ng-container *ngIf="routerURL$ | async"></ng-container>
<ion-grid class="max-w-1336">
	<ion-row>
		<p class="pb-10 Heading_S">
			{{ cohortName.name }} ( {{cohortName.id}} )
		</p>
	</ion-row>
	<ion-row>
		<ion-col size="3">
			<!--
			><ion-button [routerLink]="['/app/jobfair']">back</ion-button> -->
			<ion-grid class="side-menu-wrapper" [class.students]="class === 'students'"
				[class.groups]="class === 'groups'">
				<ion-row class="sidemenu-item ion-activatable ripple-parent" (click)="viewupdate('students')"
					[class.active]="class === 'students'">
					<ion-col class="Body_M background">
						&nbsp; 📌 Students &nbsp;
					</ion-col>
					<ion-ripple-effect></ion-ripple-effect>
				</ion-row>

				<ion-row class="sidemenu-item ion-activatable ripple-parent" (click)="viewupdate('groups')"
					[class.active]="class === 'groups'">
					<ion-col class="Body_M background">&nbsp; 📌 Groups</ion-col>
					<ion-ripple-effect></ion-ripple-effect>
				</ion-row>

				<!-- <ion-row class="sidemenu-item ion-activatable ripple-parent" (click)="viewupdate('properties')"
					[class.active]="class === 'properties'">
					<ion-col class="Body_M background">&nbsp; 📌 Properties</ion-col>
					<ion-ripple-effect></ion-ripple-effect>
				</ion-row> -->

				<!-- <ion-row class="sidemenu-item ion-activatable ripple-parent" (click)="viewupdate('jobfair-announce')"
					[class.active]="class === 'jobfair-announce'">
					<ion-col class="Body_M background">📌 Jobfair Announce</ion-col>
					<ion-ripple-effect></ion-ripple-effect>
				</ion-row> -->
				<!-- <ion-row class="sidemenu-item ion-activatable ripple-parent" (click)="viewupdate('jobfair-faq')"
					[class.active]="class === 'jobfair-faq'">
					<ion-col class="Body_M background">&nbsp; 📌 Jobfair FAQs</ion-col>
					<ion-ripple-effect></ion-ripple-effect>
				</ion-row> -->
			</ion-grid>
		</ion-col>
		<ion-col size="9">
			<router-outlet></router-outlet>
		</ion-col>
	</ion-row>
</ion-grid>